import React, { useEffect, useRef, useState } from 'react';
import {Form as RouterForm, useNavigate, useParams} from 'react-router-dom';
import { Row, Col, Card, Button, Form } from 'react-bootstrap';
import classNames from 'classnames';
import Flex from '../../common/Flex';
import {edit, listForeigner, listGender, listPosition, validateJMBG} from '../../../lib/api/player';
import { list } from '../../../lib/api/federation';
import DatePicker from 'react-datepicker';
import {item} from "../../../lib/api/player";
import {toast} from "react-toastify";
import CustomDatePicker from "../../common/CustomDatePicker";
import {useAppContext} from "../../../providers/AppProvider";

export function Edit({ playerId, initMode, onClose, onUpdate }) {
  const {userApp} = useAppContext();

  const formRef = useRef(null);
  const [mode, setMode] = useState(initMode);
  const [gender, setGender] = useState([]);
  const [foreigner, setForeigner] = useState([]);
  const [federation, setFederation] = useState([]);
  const [position, setPosition] = useState([]);
  const [player, setPlayer] = useState({});
  const [errors, setErrors] = useState({});

  const [previewImage, setPreviewImage] = useState(null);
  const fileInputRef = useRef(null);

  useEffect(() => {
    (async () => {
      const resItem = await item({ document_guid: playerId });
      const resGender = await listGender();
      const resFederation = await list();
      const resForeigner = await listForeigner();
      const resPosition = await listPosition();

      const playerItem = resItem[0];

      setPlayer(playerItem);
      setPreviewImage(process.env.REACT_APP_BASE_API_URL +`/uploads/${playerItem.image_path}`);
      setGender(resGender);
      setFederation(resFederation);
      setForeigner(resForeigner);
      setPosition(resPosition);
    })();
  }, [playerId, mode]);

  const handelInput = e => {
    const { name, value } = e.target;
    setPlayer({ ...player, [name]: value });
  };

  const handleDateChange = (name, value) => {

    console.log('xxxx',name,value )
    setPlayer(prev => {
      const updated = { ...prev };
      if (!value) {
        delete updated[name]; // obriši polje ako je null/undefined
      } else {
        updated[name] = value.toISOString().split('T')[0];
        console.log('updated',updated);
      }
      return updated;
    });

  };
  const handleImageChange = e => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => setPreviewImage(reader.result);
      reader.readAsDataURL(file);
    }
  };

  const validateForm = () => {
    const newErrors = {
      name: !player.name?.trim(),
      last_name: !player.last_name?.trim(),
      gender_type_id: !player.gender_type_id,
      is_home_club: player.is_home_club==='',
      foreigner_type_id: !player.foreigner_type_id,
      federation_entities_id: player.foreigner_type_id === '2' && !player.federation_entities_id,
      identification: !isValidIdentification(player.identification),
      certificate: isValidCertificate(player.certificate),
      date_of_birth: !player.date_of_birth,
      place: !player.place?.trim(),
      height: !player.height,
      position_type_id: !player.position_type_id
    };
    setErrors(newErrors);
    return !Object.values(newErrors).some(Boolean);
  };

  const  isValidIdentification = data => {
    if (Number(player.foreigner_type_id) === 1) {
      console.log('isValidJMBG',isValidJMBG(data), data)
      return isValidJMBG(data);
    }

    if (Number(player.foreigner_type_id) === 2) {
      return !!data; // vraća true ako data postoji, false ako je falsy (npr. null, undefined, "")
    }

    return false; // default ako nije 1 ili 2
  }

  const  isValidCertificate = data => {
    if (Number(player.foreigner_type_id) === 2) {
      return (data === null || data === undefined || data === ''); // vraća true ako data postoji, false ako je falsy (npr. null, undefined, "")
    }
    return false; // default ako nije 1 ili 2
  }

  const isValidJMBG =  jmbg => {
    // Mora imati tačno 13 cifara
    if (!/^\d{13}$/.test(jmbg)) return false;

    // Parsiranje u niz cifara
    const digits = jmbg.split('').map(Number);

    // Provjera kontrolne cifre
    const controlSum =
        7 * (digits[0] + digits[6]) +
        6 * (digits[1] + digits[7]) +
        5 * (digits[2] + digits[8]) +
        4 * (digits[3] + digits[9]) +
        3 * (digits[4] + digits[10]) +
        2 * (digits[5] + digits[11]);

    let controlDigit = 11 - (controlSum % 11);
    if (controlDigit > 9) controlDigit = 0;

    return digits[12] === controlDigit;
  }

  const handleSubmit = async event => {
    event.preventDefault();
    if (!validateForm()) return;

    const _row = await validateJMBG({player_guid: player.player_guid, identification: player.identification})
    if (_row.record_count > 0) {
      toast.error(`Igrač sa ${player.identification} JMBG već postoji u sistemu`);
      return
    }

    const formData = new FormData(formRef.current);
    if (Number(player.foreigner_type_id) === 1) {
      formData.append('certificate', '');
    }

    formData.append('descreption', '');

    const _player = await edit(Object.fromEntries(formData.entries()), playerId);

    onUpdate?.({ ..._player, document_guid: playerId });
    onClose?.();
  };

  const handleBlur = (event) => {
    const str = event.target.value;

    if (str.length < 7) {
      return {valid: false, message: "String je prekratak."};
    }

    const day = parseInt(str.substr(0, 2), 10);
    const month = parseInt(str.substr(2, 2), 10);
    const yearPart = str.substr(4, 3);

    let year;
    if (yearPart.startsWith("9")) {
      year = parseInt("1" + yearPart, 10); // npr. 993 -> 1993
    } else {
      year = parseInt("2" + yearPart, 10); // npr. 000 -> 2000
    }

    if (isNaN(day) || isNaN(month) || isNaN(year)) {
      return {valid: false, message: "Datum nije ispravno formatiran."};
    }

    const date = new Date(year, month - 1, day);

    const isValid =
        date.getFullYear() === year &&
        date.getMonth() === month - 1 &&
        date.getDate() === day;

    if (isValid) {
      setPlayer((prev) => ({...prev, date_of_birth: date}));
    }
  };

  function formatDate(value) {
    if (!value) return "";
    const date = new Date(value);
    const day = date.getDate().toString().padStart(2, "0");
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const year = date.getFullYear();
    return `${day}.${month}.${year}`;
  }

  function formatContractDate(value) {
    if (!value) return "";

    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return "";

    const day = date.getDate().toString().padStart(2, "0");
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const year = date.getFullYear().toString().slice(-2);
    return `${day}.${month}.${year}`;
  }

  const activeContract = player.contract && player.contract.terminated_at === null
    ? player.contract
    : null;

  return (
      <Card>
        <Card.Header>
            <Row className={classNames('g-2')}>
              <Col>
              <Flex>
                <h5 className="mb-0">Izmjena podataka o igraču</h5>
              </Flex>
            </Col>
          </Row>
        </Card.Header>
        <Card.Body>
          <Form ref={formRef} onSubmit={handleSubmit} encType="multipart/form-data" noValidate>
            <Row className="mb-3">
              <Col md="6">
                <Form.Label>Slika</Form.Label>
                <div
                    onClick={() => {
                      if(mode === 'edit') fileInputRef.current?.click()
                    }}
                    style={{
                      cursor: 'pointer',
                      width: 120,
                      height: 120,
                      borderRadius: '50%',
                      overflow: 'hidden',
                      border: '2px dashed #ccc',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center'
                    }}
                >
                  {previewImage ? (
                      <img
                          src={previewImage}
                          alt="Preview"
                          onError={(e) => {
                            e.target.onerror = null; // spreči loop ako fallback ne postoji
                            if (!e.target.dataset.fallbackTried) {
                              e.target.src = process.env.REACT_APP_BASE_API_URL +'/uploads/blank.jpg';
                              e.target.dataset.fallbackTried = 'true';
                            }
                          }}
                          style={{width: '100%', height: '100%', objectFit: 'cover'}}
                      />
                  ) : (
                      <span className="text-muted">Klikni za sliku</span>
                  )}
                </div>
                <Form.Control
                    type="file"
                    name="image"
                    accept="image/*"
                    style={{display: 'none'}}
                    ref={fileInputRef}
                    onChange={handleImageChange}
                />
              </Col>
            </Row>
            <Row className="mb-3">
              <Form.Group as={Col} md="6">
                <Form.Label>Ime</Form.Label>
                <Form.Control name="name" value={player.name || ''} onChange={handelInput} isInvalid={errors.name} autoComplete="off" disabled={mode !== 'edit'}/>
              </Form.Group>
              <Form.Group as={Col} md="6">
                <Form.Label>Prezime</Form.Label>
                <Form.Control name="last_name" value={player.last_name || ''} onChange={handelInput} isInvalid={errors.last_name} autoComplete="off" disabled={mode !== 'edit'}/>
              </Form.Group>
            </Row>
            <Row className="mb-3">
              <Form.Group as={Col} md="6">
                <Form.Label>Pol</Form.Label>
                <Form.Select name="gender_type_id" value={player.gender_type_id || ''} onChange={handelInput}
                             isInvalid={errors.gender_type_id} disabled={mode !== 'edit'}>
                  <option value="">Izaberi</option>
                  {gender.map(f => <option key={f.gender_type_id} value={f.gender_type_id}>{f.name}</option>)}
                </Form.Select>
              </Form.Group>

              <Form.Group as={Col} md="6">
                <Form.Label>Matični klub</Form.Label>
                <Form.Select name="is_home_club" value={String(player.is_home_club) || ''} onChange={handelInput}
                             isInvalid={errors.is_home_club} disabled={userApp.role_type_id === "clubs" || mode !== 'edit'}>
                  <option value="">Izaberi</option>
                  <option value="0">Ne</option>
                  <option value="1">Da</option>
                </Form.Select>
              </Form.Group>

            </Row>
            <Row className="mb-3">
              <Form.Group as={Col} md="6">
                <Form.Label>Stranac</Form.Label>
                <Form.Select name="foreigner_type_id" value={player.foreigner_type_id || ''} onChange={handelInput} isInvalid={errors.foreigner_type_id} disabled={mode !== 'edit'}>
                  <option value="">Izaberite</option>
                  {foreigner.map(f => <option key={f.foreigner_type_id} value={f.foreigner_type_id}>{f.name}</option>)}
                </Form.Select>
              </Form.Group>
              {player.foreigner_type_id === '2' && (
                  <Form.Group as={Col} md="6">
                    <Form.Label>Savez</Form.Label>
                    <Form.Select name="federation_entities_id" value={player.federation_entities_id || ''} onChange={handelInput} isInvalid={errors.federation_entities_id} disabled={mode !== 'edit'}>
                      <option value="">Izaberite</option>
                      {federation.map(f => <option key={f.federation_id} value={f.entities_id}>{f.name}</option>)}
                    </Form.Select>
                  </Form.Group>
              )}
            </Row>
            <Row className="mb-3">
              <Form.Group as={Col} md="6">
                <Form.Label>{Number(player.foreigner_type_id)=== 1 ? 'JMBG' : 'Broj pasoša'}</Form.Label>
                <Form.Control name="identification" value={player.identification || ''} onChange={handelInput} isInvalid={errors.identification} onBlur={handleBlur} autoComplete="off" disabled={mode !== 'edit'}/>
              </Form.Group>
              {String(player.foreigner_type_id) === '2' && (
                  <Form.Group as={Col} md="6">
                    <Form.Label>Sertifikat</Form.Label>
                    <Form.Control name="certificate" value={player.certificate || ''} onChange={handelInput} isInvalid={errors.certificate} autoComplete="off"/>
                  </Form.Group>
              )}
            </Row>
            <Row className="mb-3">
              <Form.Group as={Col} md="6">
                <Form.Label>Datum rođenja</Form.Label>
                <CustomDatePicker
                    name="date_of_birth"
                    selectedDate={player.date_of_birth ? new Date(player.date_of_birth) : null}
                    onChange={handleDateChange}
                    className={`form-control ${errors.date_of_birth ? 'is-invalid' : ''}`}
                    dateFormat="dd.MM.yyyy" autoComplete="off"
                    withPortal={false}
                    disabled={mode !== 'edit'}
                />
                <input
                    type="hidden"
                    name="date_of_birth"
                    value={player.date_of_birth ? formatDate(player.date_of_birth)  : ""}
                    disabled={mode !== 'edit'}
                />
              </Form.Group>
              <Form.Group as={Col} md="6">
                <Form.Label>Mjesto</Form.Label>
                <Form.Control name="place" value={player.place || ''} onChange={handelInput} isInvalid={errors.place} autoComplete="off" disabled={mode !== 'edit'}/>
              </Form.Group>
            </Row>
            <Row>
              <Form.Group as={Col} md="6">
                <Form.Label>Visina</Form.Label>
                <Form.Control name="height" value={player.height || ''} onChange={handelInput} isInvalid={errors.height} autoComplete="off" disabled={mode !== 'edit'}/>
              </Form.Group>
              <Form.Group as={Col} md="6">
                <Form.Label>Pozicija</Form.Label>
                <Form.Select name="position_type_id" value={player.position_type_id || ''} onChange={handelInput} isInvalid={errors.position_type_id} disabled={mode !== 'edit'}>
                  <option value="">Izaberite</option>
                  {position.map(p => <option key={p.position_type_id} value={p.position_type_id}>{p.name}</option>)}
                </Form.Select>
              </Form.Group>
            </Row>
            {mode === 'edit' && (
            <Button type="submit" className="mt-3">Sačuvaj izmjene</Button>
            )}
            {activeContract && (
              <>
                <hr className="my-3" />
                <div className="text-muted">
                  <span className="fw-semibold text-body">Ugovor: </span>
                  <span className="fw-semibold text-primary">{activeContract.document_id}</span> Ugovor važi do{' '}
                  <span className="fw-semibold text-primary">{formatContractDate(activeContract.valid_to)}</span> - {activeContract.club_name}
                </div>
              </>
            )}
          </Form>
        </Card.Body>
      </Card>
  );
}
